module.exports = __webpack_public_path__ + "static/img/image002.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/image002.gif
// module id = UhEo
// module chunks = 1